<template>
  <div>
    <el-cascader
      v-if="type === 'tree' && showCascader"
      :clearable="clearable"
      :size="size"
      :key="cascaderKey"
      v-model="val"
      :disabled="disabled"
      :placeholder="placeholder"
      :options="list"
      :props="props"
      @change="onChange"
      :filterable="filterable"
      :style="{ width: width, verticalAlign: 'top' }"
      :show-all-levels="showAllLevels"
      ref="tree"
    ></el-cascader>
    <el-select
      v-if="type === 'select'"
      :allow-create="allowCreate"
      :default-first-option="defaultFirstOption"
      :clearable="clearable"
      :size="size"
      :filterable="filterable"
      v-model="val"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="onChange"
      @clear="onClear"
      :style="{ width: width, verticalAlign: 'top', boder: noBoder ? 'none' : '' }"
      :multiple="multiple"
      :multipleLimit="multipleLimit"
      :reserve-keyword="reserveKeyword"
      :remote="remote"
      :remote-method="remoteMethod"
      :collapse-tags="collapseTags"
    >
      <el-option v-for="(item, index) in listFilter(list)" :key="index" :label="item[props.label] || item[props.value]" :value="`${item[props.value]}`" :disabled="item.disabled" />
    </el-select>
  </div>
</template>

<script>
import apis from '@/utils/apis';

// 判断两个对象是否一致
function isSameObj(obj1, obj2) {
  if (!obj1 && !obj2) {
    return false;
  }
  if ((obj1 && !obj2) || (!obj1 && obj2)) {
    return true;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== undefined && keys2.length !== undefined) {
    if (keys1.length !== keys2.length) {
      return false;
    }
    let flag = true;

    keys1.forEach((key) => {
      if (obj1[key] !== obj2[key]) {
        flag = false;
      }
    });

    return flag;
  }

  return false;
}

export default {
  props: {
    model: [Object, Array],
    collapseTags: { type: Boolean, default: false },
    data: [Array], // 下拉数据
    type: { type: String, default: 'select' },
    width: { type: String },
    value: [String, Array, Number],
    placeholder: { type: String },
    cascaderKey: { type: String },
    size: { type: String, default: 'small' },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    defaultFirstOption: { type: Boolean, default: false },
    listener: [String, Number], // 监听变更初始化下拉列表
    isDefault: {
      type: Boolean, // 默认选中第一项
      default: false,
    },
    auto: {
      type: Boolean, // 自动加载
      default: true,
    },
    code: {
      type: String, // 字典编码
      default: '',
    },
    url: {
      type: String, // 请求地址
      default: '',
    },
    method: {
      type: String, // 请求地址
      default: 'GET',
    },
    params: {
      type: Object, // 请求参数
      default() {
        return {};
      },
    },
    props: {
      type: Object, // 选项配置
      default() {
        return { label: 'name', value: 'value' };
      },
    },
    multiple: {
      type: Boolean, // 是否多选
      default: false,
    },
    multipleLimit: {
      type: Number, // 多选项数量限制
    },
    valueType: {
      type: String, // 绑定的value类型
    },
    dataFilter: {
      type: Function, // 列表过滤方法
    },
    filterOptions: [Object, Number, String, Array],
    showAllLevels: {
      type: Boolean,
      default: true,
    },
    // 完整请求地址
    fullUrl: {
      type: String,
      default: '',
    },
    noBoder: {
      type: Boolean,
      default: false,
    },
    remote: {
      type: Boolean,
      default: false,
    },
    reserveKeyword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: '',
      list: [],
      loadingCode: false,
      showCascader: true,
      isInit: true,
      // 请求防抖
      getSelectListHandler: null,
    };
  },
  watch: {
    data() {
      this.list = this.data || [];
      this.setDefault();
    },
    value() {
      this.initData();
    },
    code() {
      this.list = [];
      this.$emit('input', '');
      this.getSelectList();
    },
    url() {
      this.list = [];
      this.$emit('input', '');
      this.getSelectList();
    },
    dataFilter() {
      this.list = [];
      this.$emit('input', '');
      this.getSelectList();
    },
    filterOptions(a, b) {
      if (!isSameObj(a, b)) {
        this.list = [];
        this.$emit('input', '');
        // this.getSelectList();
      }
    },
    listener() {
      this.list = [];
      if (!`${this.listener}`.includes('null')) {
        // !`${this.listener}`.includes('true') 在listener上拼个true 规避一下有值也要调用  暂时合同用到
        if (!this.remote || (this.remote && !this.val && `${this.listener}`.includes('true')) || (this.remote && this.val && !`${this.listener}`.includes('true'))) {
          // remote会自己调用 如果有值remote就不会自动调了 则续手动调一下
          this.getSelectList();
        }
      } else {
        this.$emit('input', '');
        this.$emit('change');
      }
    },
  },
  mounted() {
    this.list = this.data || [];
    this.initData();
    if (this.auto) {
      this.getSelectList();
    }
    if (this.remote) {
      this.getSelectListHandler = this.$debounce(() => {
        // 防抖处理  表格重绘
        this.getRemoteSelectList();
      }, 200);
    }
  },
  methods: {
    // 控制custom-select的val，避免外部传入数值0且在list中匹配不到时，custom-select的“0”值显示
    initVal() {
      if (this.type === 'select') {
        if (this.list && this.list.length && !Array.isArray(this.value) && (this.value === 0 || this.value === '0')) {
          // this.val是否在this.list中找到
          const valInList = this.list.some((item) => `${item[this.props.value]}` === `${this.val}`);
          // 如果this.val在this.list中匹配不到，则将el-select的value置空，保留外层的value
          if (!valInList) {
            this.val = '';
          }
        }
      }
    },
    initData: function () {
      if (typeof this.value === 'number') {
        this.val = `${this.value}`;
        this.$emit('input', this.val);
        this.initVal();
        return;
      }
      if (Array.isArray(this.value)) {
        this.val = this.value.map((t) => `${t}`);
        return;
      }
      this.val = this.value;
      this.initVal();
    },
    // 数据过滤
    listFilter(list) {
      if (!this.dataFilter) {
        return list;
      }
      return this.dataFilter(list, this.filterOptions);
    },
    // 设置默认值
    setDefault() {
      if (this.isDefault && this.list.length && !this.value) {
        this.$emit('input', this.list[0][this.props.value]);
        this.$emit('init', this.list[0]);
        this.$emit('change', this.list[0]);
      }
    },
    // 获取字典
    getSelectList: function () {
      if (this.code) {
        this.getDictionary(this.code, (dictionary) => {
          const list = dictionary[this.code];
          this.list = this.listFilter(list);
          this.$emit('getList', list);
          this.setDefault();
          this.initVal();
          this.emitInit();
        });
        return;
      }
      if (this.url || this.fullUrl) {
        // GET
        if (this.method === 'GET') {
          this.$getJSON(this.fullUrl || apis[this.url], this.params).then((res) => {
            const list = res.data || [];
            this.list = this.listFilter(list);
            this.$emit('getList', list);
            this.setDefault();
            this.initVal();
            this.emitInit();
            if (this.value && !this.remote) {
              this.onChange();
            }
          });
        } else {
          // POST
          this.$postJSON(this.fullUrl || apis[this.url], this.params).then((res) => {
            const list = res.data || [];
            this.list = this.listFilter(list);
            this.$emit('getList', list);
            this.setDefault();
            this.initVal();
            this.emitInit();
            if (this.value && !this.remote) {
              this.onChange();
            }
          });
        }
        return;
      }
      this.list = this.data || [];
    },
    // 获取选中节点列表
    getCheckedNodes() {
      const nodes = this.$refs.tree.getCheckedNodes();
      if (!nodes.length || !nodes[0]) {
        return nodes;
      }
      if (nodes[0] === null) {
        return [];
      }
      const pathNodes = nodes[0].pathNodes;
      return pathNodes.map((item) => item.data);
    },
    getCheckedLabel() {
      const nodes = this.$refs.tree.getCheckedNodes(); // 获取选中的节点
      if (!nodes.length) {
        return nodes;
      }
      const label = nodes.map((node) => node && node.label); // 提取 label
      return label[0];
    },
    // 远程加载消息名称下拉项
    remoteMethod: function (query) {
      this.getRemoteSelectList(query);
    },
    // 防抖处理
    getRemoteSelectList(query) {
      if (!this.val && !query) {
        return;
      }
      this.loadingCode = true;
      this.$getJSON(apis[this.url], { ...this.params, keyword: query, search: query }, true).then((res) => {
        this.loadingCode = false;
        const list = res.data;
        this.list = list;
        // this.list = query ? list.filter(item => item[this.props.label].toLowerCase().indexOf(query.toLowerCase()) > -1) : list;
      });
    },
    emitInit() {
      if (this.isInit && this.val) {
        this.isInit = false;
        const item = this.list.find((t) => `${t[this.props.value]}` === `${this.val}`);
        this.$emit('init', item);
      }
    },
    // 选中值
    onChange: function () {
      this.$emit('input', this.val);
      if (this.type === 'tree') {
        this.$nextTick(() => {
          if (this.props.checkStrictly && !this.props.multiple) {
            this.$refs.tree.dropDownVisible = false;
          }
        });
        this.$emit('change');
        this.$emit('treeValChangeLabel', this.getCheckedLabel());
        this.$emit('treeValChange', this.getCheckedNodes());
      }
      if (Array.isArray(this.val)) {
        const item = this.val.map((t) => this.list.find((f) => `${f[this.props.value]}` === t));
        // const map = this.props.map;
        // console.log(1111);
        // console.log(item);
        // if (this.model && map) {
        //   Object.keys(map).forEach((key) => {
        //     if (item.length) {
        //       this.model[map[key]] = item.map(t => t[key]);
        //     } else {
        //       this.model[map[key]] = [];
        //     }
        //   });
        // }
        if (this.model) {
          this.model['multiple'] = item;
        }
        this.$emit('change', item);
        return;
      }
      const item = this.list.find((t) => `${t[this.props.value]}` === `${this.val}`);
      const map = this.props.map;
      if (this.model && map) {
        Object.keys(map).forEach((key) => {
          if (item) {
            this.model[map[key]] = item[key];
          } else {
            this.model[map[key]] = '';
          }
        });
      }
      if (this.remote) {
        // 远程搜索  选中后要把之前的都显示出来 要不然现在的数据是远程搜索后的  会出现上次过滤后的数据
        this.remoteMethod();
      }
      this.$emit('change', item);
    },
    onClear: function () {
      this.$emit('clear');
    },
    // 获取下拉框选中的item
    getSelectedNode() {
      const valueKey = this.props.value;
      const item = this.list.find((obj) => `${obj[valueKey]}` === `${this.val}`);
      return item;
    },
  },
};
</script>
<style></style>
